import { strokeStyle } from "./stroke";

function ChevronLeft({ color = "currentColor" }) {
  return (
    <svg
      aria-hidden="true"
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={strokeStyle(color)}
    >
      <path d="M15 18l-6-6 6-6" />
    </svg>
  );
}

export default ChevronLeft;
